import { render, staticRenderFns } from "./PropostaEditEmitente.vue?vue&type=template&id=56dc6244"
import script from "./PropostaEditEmitente.vue?vue&type=script&lang=js"
export * from "./PropostaEditEmitente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports